import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";

const LINKS = [
  { id: "home", label: "Home" },
  { id: "smaken", label: "Onze smaken" },
  { id: "bestellen", label: "Zakelijk bestellen" },
  { id: "reviews", label: "Reviews" },
  { id: "verkooppunten", label: "Verkooppunten" },
  { id: "contact", label: "Contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 60);
    on();
    window.addEventListener("scroll", on, { passive: true });
    return () => window.removeEventListener("scroll", on);
  }, []);

  const go = (id) => {
    setOpen(false);
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 120);
    } else {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <header
      data-testid="main-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-[background-color,padding,box-shadow] duration-500 ${
        scrolled ? "glass py-3 shadow-2xl shadow-black/40" : "bg-transparent py-5"
      }`}
    >
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-5 lg:px-10">
        <button data-testid="nav-logo" onClick={() => go("home")} className="flex items-center gap-3 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary rounded-xl">
          <img src="/soulfoodcity-logo.webp" alt="Soul Food City Drinks logo" className="h-11 w-11 rounded-full object-cover ring-1 ring-white/15" />
          <span className="hidden font-display text-lg tracking-wide text-white sm:block">
            SOUL FOOD CITY <span className="text-sfc-orange">DRINKS</span>
          </span>
        </button>

        <div className="hidden items-center gap-1 lg:flex">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => go(l.id)}
              className="rounded-full px-4 py-2 text-sm font-medium text-white/80 transition-colors duration-300 hover:text-white hover:bg-white/10 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-order-cta"
            onClick={() => go("bestellen")}
            className="ml-2 rounded-full bg-gradient-to-r from-sfc-orange to-sfc-red px-5 py-2.5 text-sm font-semibold text-white transition-transform duration-300 hover:scale-105"
          >
            Zakelijk bestellen
          </button>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((v) => !v)}
          className="rounded-full p-2 text-white lg:hidden focus:outline-none focus-visible:ring-2 focus-visible:ring-primary"
          aria-label="Menu openen"
          aria-expanded={open}
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </nav>

      {open && (
        <div data-testid="nav-mobile-menu" className="mx-4 mt-3 rounded-3xl glass p-4 lg:hidden">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-mobile-${l.id}`}
              onClick={() => go(l.id)}
              className="block w-full rounded-xl px-4 py-3 text-left text-base text-white/85 hover:bg-white/10"
            >
              {l.label}
            </button>
          ))}
        </div>
      )}
    </header>
  );
}
